import { AxiosResponse } from "axios";
import { axiosInstance } from "./common";

import {CreditAccountCurrentPosition} from "./credit_account_current_positions";

import {CreditAccountDetails} from "./credit_account_details";

import {CreditAccountProvisionDetails} from "./credit_account_provisions";

import {CreditAccountRecoveryDetails} from "./credit_account_recovery";

export interface AccountOverview {
  account_number: string;
  credit_account_details?: CreditAccountDetails | null;
  current_position?: CreditAccountCurrentPosition | null;
  provision_details?: CreditAccountProvisionDetails | null;
  recovery_details?: CreditAccountRecoveryDetails | null;
}

export interface GetAccountOverviewsResponse {
  account_overviews: AccountOverview[];
}

export const AccountOverviewsAPI = {
  get: async (case_id: string) => {
    const response: AxiosResponse<GetAccountOverviewsResponse> =
      await axiosInstance.get(
        `/v1/cases/${case_id}/account-overviews`
      );

    return response.data;
  },
};